import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import "tw-elements";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
